import { ApiFullAddress, apiFullAddressToAddress } from "../../apiResponse/address";

export declare interface ApiExternalAddress {
  Address: ApiFullAddress;
  ForeignAddress: string;
}

export declare interface ExternalAddress {
  /** addressId of the external address */
  addressId: string;
  domain: string;
  /** the external sip address being added to the account */
  foreignAddress: string;
  /** The display name for the external sip address */
  name: string;
  /** the interal sip address that will point to the external sip address - combined username and domain */
  aor: string;
  /** internal username - this is just the display name */
  username: string;
}

export function apiExternalAddressToExternalAddress(
  apiExternalAddress: ApiExternalAddress
): ExternalAddress {
  const address = apiFullAddressToAddress(apiExternalAddress.Address);
  return {
    addressId: address.addressId,
    domain: address.domain,
    foreignAddress: apiExternalAddress.ForeignAddress,
    name: address.name,
    aor: address.username + "@" + address.domain,
    username: address.username
  };
}
